export const searchHandler = ({
  fetchFunction,
  paramKey = 'search',
  debounceTime = 600,
  params,
  setParams,
  debounceRef,
}: {
  fetchFunction: (params: Record<string, any>) => Promise<void>
  paramKey?: string
  debounceTime?: number
  params: Record<string, any>
  state?: string
  setParams: (params: Record<string, any>) => void
  debounceRef: React.MutableRefObject<NodeJS.Timeout | null>
}) => {
  return (event: React.ChangeEvent<HTMLInputElement>) => {
    const text = event.target.value

    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
    }

    const updatedParams = { ...params }

    if (!text || text.trim() === '') {
      updatedParams[paramKey] = null
      setParams(updatedParams)
      fetchFunction(updatedParams)
      return
    }

    debounceRef.current = setTimeout(() => {
      updatedParams[paramKey] = text
      setParams(updatedParams)
      fetchFunction(updatedParams)
    }, debounceTime)
  }
}
